module.exports = __webpack_public_path__ + "static/media/dashboard_icon.c0183957.svg";